import {
  formatNumber,
  NgFor, NgIf
} from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AngularEditorConfig, AngularEditorModule } from '@kolkov/angular-editor';
import { ToastrService } from 'ngx-toastr';
import { DialogModule } from 'primeng/dialog';
import { AddReceipe } from '../../models/add-receipe';
import { Ingredients } from '../../models/ingredients';
import { RecipeService } from '../../services/recipe.service';


@Component({
  selector: 'app-add-recipe',
  standalone: true,
  imports: [FormsModule,DialogModule,NgIf,NgFor,AngularEditorModule], 
  templateUrl: './add-recipe.component.html',
  styleUrls: ['./add-recipe.component.css']
})
export class AddRecipeComponent {
   category:any;
  chips: [['chip'], []]
  categories:any=[];
  cols:any=[];
  rows: any[] = [];
  rowStep:any[]=[];
  ingrident:any=[];
  tags = {
    dietTags: [] as any[],
    allergyTags: [] as any[]
  };

   editorConfig: AngularEditorConfig = {
  editable: true,
  spellcheck: true,
  height: '200px',
  minHeight: '100px',
  placeholder: 'Enter text here...',
  translate: 'no',
  toolbarHiddenButtons: [[], []] 
};



   receipe: AddReceipe = {
    recipeName: '',
    normalizeRecipeName: '',
    shortDescription: '',
    note: '',
    referenceLink: '',
    recipeImageUpload: '',
    evaporate: 0,
    totalMeasure: 0,
    totalCals: 0,
    totalProtien: 0, 
    totalCarbs: 0,
    totalFats: 0,
    prepTime: '',
    createdBy: 0,
    recipeType: '',
    ingredients: [],
    preparationSteps: [],
     diets: [],
  allergies: [],
  };

  isSearchBox:boolean=false;
 
  ingredient:Ingredients={
    ingredientTitle:'',
    ingredientType:'',
    ingredientDescription:'',
    cals:{
      "value": "",
      "type": "g"
    },
    protien:{
      "value": "",
      "type": "g"
    },
    fats:{
      "value": "",
      "type": "g"
    },
    carbs:{
      "value": "",
      "type": "g"
    },
    fibre:{
      "value": "",
      "type": "g"
    },
    calcium:{
      "value": "",
      "type": "mg"
    },
    iron:{
      "value": "",
      "type": "mg"
    },
    zinc:{
      "value": "",
      "type": "mg"
    },
    potassium:{
      "value": "",
      "type": "mg"
    },
    sodium:{
      "value": "",
      "type": "mg"
    },
    vitaminA:{
      "value": "",
      "type": "mcg"
    },
    VitaminC:{
      "value": "",
      "type": "mg"
    },
    Omega3:{
      "value": "",
      "type": "mg"
    },
    allergies:[],
    diets:[],
    

  }; 
  tagName:string;
  tagType:any ='';
  visible:boolean=false;  
  visibleTag:boolean=false; 
  allergies:any=[];
  diets:any = [];
  userDetails:any=[];
  timeout: any = null;
  searchIngredientResult:any=[];
  showPleaseText:boolean=true;
  measureUnit:string;
  recipeType:any;
  selectedTypes:any=[];
  file: File;
  fileName:string;
  createdIngredientDetails:any=[];
  searchTextMessage:string='Please wait..';
  constructor(private RecipeService:RecipeService,private toastr: ToastrService, private router: Router) {
    
  }
disabled = true;

    items = [];

  ngOnInit(): void {
   // this.recipeType=['Mediterranean Diet','Low-Carb Diet','Intermittent Fasting','Paleo Diet','Vegan Diet','Raw Food Diet','Ketogenic Diet'];
    this.ingredient.diets.slice(0);
    this.allergies=['Gluten','Dairy','Eggs','Soy','Wheat','Fish','Shellfish','Tree Nuts','Peanuts'];
    this.diets=['Hindu Vegetarian','Hindu Non-Veg','Non Vegetarian','Pescatarian','Eggetarian','Jain','Lacto-Vegetarian','Vegan','Halal','Low Fat','Low Cholesterol','Low Sodium','Gluten Intolerant','Paleo','High Fiber','High Protein','Low Carb','Low Sugar'];
     this.fetchTags();
     this.rows.push({
      // id: '',
      ingredientId:'',
      qty:'',
     searchIngredents:[],
      isSearchBoxShow:false,
      ingredientName:'',
      measureunit:[],
      realCals:'0',
      realProtein:'0',
      realCarbs:'0',
      realFat:'0',
      measure:'',
      measurement:[],
      measurementUnitValue:'',
      ingredientType:''
     });
     this.rowStep.push({
      // id: '',
     
      //step:'',
      description:''
     
      
     }); 
    this.cols = [
      { field: 'Ingredients', header: 'Ingredients' },
      { field: 'Qty', header: 'Qty' },
      { field: 'Note', header: 'Note' },
      { field: 'cals', header: 'Cals' },
      { field: 'protien', header: 'Protien' },
      { field: 'carbs', header: 'Carbs' },
      { field: 'fat', header: 'Fat' },
      { field: 'action', header: 'Action' }
  ];
    this.categories = ['Veg','Non-Veg','Salad'];

    
    
  }
  public options = {
    readonly: undefined,
    placeholder: '+ Tag'
};
  addRow() {
  let indexForId = this.rows.length + 1;
  this.rows.push({
    id: indexForId,
    name: '',
    searchIngredents: [],
    isSearchBoxShow: false,
    ingredientId: '', 
    ingredientName: '',
    qty: '',           
    measureunit: [],
    realCals: '0',
    realProtein: '0',
    realCarbs: '0',
    realFat: '0',
    measure: '',
    measurement: [],
    measurementUnitValue: '',
    ingredientType: ''
  });
}

  deleteRow(d:any){
    if(d > 0){
    const index = this.rows.indexOf(d);
    this.rows.splice(index, 1);
    }

}

deleteRowStep(d:any){
  
  if(d > 0){
  const index = this.rowStep.indexOf(d);
  this.rowStep.splice(index, 1);
}
}

addStepRow() {
  let indexForId = this.rowStep.length + 1
  this.rowStep.push({
   // step:'',
      description:''
  });
}

onChange(event:any) {
  this.receipe.recipeImageUpload = event.target.files[0];
 // console.log(this.receipe.receiptImage);
}
addReceipe() {
  this.receipe.preparationSteps = this.rowStep
    .filter((step: any) => step?.description?.toString().trim())
    .map((step: any, index: number) => ({
      step: `Step ${index + 1}`,
      description: step.description
    }));

  this.ingrident = [];
  this.receipe.totalMeasure = 0;
  let hasValidIngredient = false;

  const now = new Date().toISOString();

  for (let i = 0; i < this.rows.length; i++) {
    const row = this.rows[i];

    if (!row.ingredientId && !row.ingredientName && !row.qty && !row.measure) continue;

    if (!row.ingredientId || !row.ingredientName || !row.qty || !row.measure) {
      this.toastr.error(`Please complete all fields for ingredient row ${i + 1}.`);
      return;
    }

    const qty = Number(row.qty);
    const unitValue = Number(row.measurementUnitValue);

    if (!qty || isNaN(qty) || qty <= 0) {
      this.toastr.error(`Please enter a valid quantity for ingredient row ${i + 1}.`);
      return;
    }

    if (!unitValue || isNaN(unitValue)) {
      this.toastr.error(`Please select a valid measurement unit for ingredient row ${i + 1}.`);
      return;
    }

    hasValidIngredient = true;

    const isLiquid = row.ingredientType === 'Liquid';
    const specialLiquids = [
      'Milk, whole, Buffalo', 'Milk, whole, Cow', 'Milk fish',
      'Water', 'coconut milk', 'Almond milk'
    ];
    let calValue = unitValue;

    if (isLiquid && specialLiquids.includes(row.ingredientName)) {
      const evaporateValue = Number(this.receipe.evaporate);
      if (!evaporateValue || evaporateValue < 1 || isNaN(evaporateValue)) {
        this.toastr.error('Please enter a valid evaporate percentage (e.g., 10 for 10%).');
        return;
      }
      calValue = unitValue - (evaporateValue * unitValue) / 100;
    }

    this.receipe.totalMeasure += calValue;

    this.ingrident.push({
      ingredientId: row.ingredientId,
      ingredientName: row.ingredientName,
      ingredientCode: row.ingredientCode || '',
      ingredientDescription: row.ingredientDescription || '',
      ingredientType: row.ingredientType || '',
      qty,
      recipeQuantity: qty, 
      measureUnit: row.measure,
      measureUnitValue: unitValue,
      cals: { value: row.Cals || '0', type: 'kcal' }, 
      protien: { value: row.Protien || '0', type: 'g' },
      fats: { value: row.Fats || '0', type: 'g' },
      carbs: { value: row.Carbs || '0', type: 'g' },
      fibre: { value: row.Fibre || '0', type: row.FibreType || 'g' },
      calcium: { value: row.Calcium || '0', type: row.CalciumType || 'mg' },
      iron: { value: row.Iron || '0', type: row.IronType || 'mg' },
      zinc: { value: row.Zinc || '0', type: row.ZincType || 'mg' },
      potassium: { value: row.Potassium || '0', type: row.PotassiumType || 'mg' },
      sodium: { value: row.Sodium || '0', type: row.SodiumType || 'mg' },
      vitaminA: { value: row.VitaminA || '0', type: row.VitaminAType || 'mcg' },
      vitaminC: { value: row.VitaminC || '0', type: row.VitaminCType || 'mg' },
      omega3: { value: row.Omega3 || '0', type: row.Omega3Type || 'mg' },
      diet: row.Diet ?? [],
      allergies: row.Allergies ?? [],
      status: 'Active',
      addedBy: this.RecipeService.getLoggedUser().id.toString(),
      createdDateTime: now, 
      modifiedDateTime: now
    });
  }

  if (!hasValidIngredient) {
    this.toastr.error('Please add at least one complete ingredient.', '', {
  positionClass: 'toast-top-center'
});

    return;
  }

  if (!this.receipe.recipeName?.trim()) {
    this.toastr.error('Recipe name is required.');
    return;
  }

  this.receipe.evaporate = Number(this.receipe.evaporate || 0);
  if (isNaN(this.receipe.evaporate)) {
    this.toastr.error('Evaporate must be a valid number.');
    return;
  }

  this.receipe.totalMeasure = Number(this.receipe.totalMeasure || 0);
  this.receipe.totalCals = Number(this.receipe.totalCals || 0);
  this.receipe.totalCarbs = Number(this.receipe.totalCarbs || 0);
  this.receipe.totalFats = Number(this.receipe.totalFats || 0);
  this.receipe.totalProtien = Number(this.receipe.totalProtien || 0);

  // Handle image upload with the fix
  if (this.file) {
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result as string;
      const encodedImage = base64String.split(',')[1];
      this.sendRecipe(encodedImage, now);
    };
    reader.readAsDataURL(this.file);
  } else {
    this.sendRecipe('', now); // no image provided
  }
}

// Helper method to send the recipe
private sendRecipe(encodedImage: string, now: string) {
  const payload: any = {
    recipeName: this.receipe.recipeName,
    normalizeRecipeName: this.receipe.recipeName?.toLowerCase().trim() || '',
    recipeType: this.receipe.recipeType,
    shortDescription: this.receipe.shortDescription,
    note: this.receipe.note,
    referenceLink: this.receipe.referenceLink,
    recipeImageUpload: encodedImage,
    evaporate: this.receipe.evaporate,
    totalMeasure: this.receipe.totalMeasure,
    totalCals: this.receipe.totalCals,
    totalProtien: this.receipe.totalProtien,
    totalCarbs: this.receipe.totalCarbs,
    totalFats: this.receipe.totalFats,
    prepTime: this.receipe.prepTime,
    createdBy: this.RecipeService.getLoggedUser().id,
    createdDateTime: now,
    modifiedDateTime: now,
    ingredients: this.ingrident,
    preparationSteps: this.receipe.preparationSteps,
    diets: this.receipe.diets || [],
    allergies: this.receipe.allergies || []
  };

  console.log("Final Recipe Payload:", payload);

  this.RecipeService.addReciepe(payload).subscribe({
    next: () => {
      this.toastr.success('Recipe added successfully.');
      this.router.navigate(['/recipes']);
    },
    error: (error) => {
      console.error('Recipe submission failed:', error);
      if (error.error?.message) {
        console.error('Backend error message:', error.error.message);
        this.toastr.error(error.error.message, 'Recipe Error');
      } else if (typeof error.error === 'string') {
        console.error('Raw error:', error.error);
        this.toastr.error(error.error, 'Recipe Error');
      } else {
        console.error('Unknown backend error:', error);
        this.toastr.error('An unknown error occurred while submitting the recipe.', 'Error');
      }
    }
  });
}

addNewIngredientForm() {
 
  this.ingredient = {
    ...this.ingredient, 
    ingredientTitle: '',
    ingredientType: '',
    ingredientDescription: '',
    cals: { value: "", type: "g" },
    protien: { value: "", type: "g" },
    fats: { value: "", type: "g" },
    carbs: { value: "", type: "g" },
    fibre: { value: "", type: "g" },
    calcium: { value: "", type: "mg" },
    iron: { value: "", type: "mg" },
    zinc: { value: "", type: "mg" },
    potassium: { value: "", type: "mg" },
    sodium: { value: "", type: "mg" },
    vitaminA: { value: "", type: "mcg" },
    VitaminC: { value: "", type: "mg" },
    Omega3: { value: "", type: "mg" },
    allergies: [],
    diets: []
  };
  
  this.visible = true;
}
addNewTag(){
  this.visibleTag=true;
}

// selectedDiet(diet:any,ischeck:any,type:any){
//   if(type == 1){
//     if(ischeck == true){
      
//       this.intgredient.diets.push(diet);
//     }else{
//       this.intgredient.diets.splice(this.intgredient.diets.indexOf(diet), 1);
//     }
//   }
//   else if(type == 2){
//     if(ischeck == true){
      
//       this.receipe.diets.push(diet);
//     }else{
//       this.receipe.diets.splice(this.receipe.diets.indexOf(diet), 1);
//     }
//   }
// }

// selectedAllegrie(allergies:any,ischeck:any,type:any){
//   if(type == 1){
//     if(ischeck == true){
//       this.intgredient.allergies.push(allergies);
//     }else{
//       this.intgredient.allergies.splice(this.intgredient.diets.indexOf(allergies), 1);
//     }
//   }
//   else if(type == 2){
//     if(ischeck == true){
//       this.receipe.allergies.push(allergies);
//     }else{
//       this.receipe.allergies.splice(this.intgredient.diets.indexOf(allergies), 1);
//     }
//   }
// }

addNewIngredient() {
  this.userDetails = this.RecipeService.getLoggedUser();
  this.ingredient.addedBy = this.userDetails.id;

  if (this.ingredient.ingredientTitle == '' || this.ingredient.ingredientType == '') {
    this.toastr.error('Please fill all values.');
    return;
  }

  this.RecipeService.addIngredient(this.ingredient).subscribe((response: any) => {
    this.createdIngredientDetails = response;
    console.log('Returned ingredient from backend:', response);

    
    if (!this.createdIngredientDetails.ingredientType) {
      this.createdIngredientDetails.ingredientType = this.ingredient.ingredientType;
    }

    this.toastr.success('Ingredient added successfully.');
    this.visible = false;

    if (this.rows.length < 2 && this.rows[0].ingredientId == '') {
      this.rows[0].ingredientId = this.createdIngredientDetails.id;
      this.rows[0].ingredientName = this.ingredient.ingredientTitle;
      this.rows[0].qty = 1;
      this.rows[0].cals = this.ingredient.cals.value;
      this.rows[0].protien = this.ingredient.protien.value;
      this.rows[0].carbs = this.ingredient.carbs.value;
      this.rows[0].fat = this.ingredient.fats.value;
      this.rows[0].realCals = this.ingredient.cals.value;
      this.rows[0].realProtein = this.ingredient.protien.value;
      this.rows[0].realCarbs = this.ingredient.carbs.value;
      this.rows[0].realFat = this.ingredient.fats.value;
      this.rows[0].ingredientType = this.ingredient.ingredientType;

      this.calculateMeasure(this.createdIngredientDetails.ingredientType, 0);
      

    } else {
      let index = this.rows.length;

      this.rows.push({
        id: index + 1,
        ingredientId: this.createdIngredientDetails.id,
        ingredientName: this.ingredient.ingredientTitle,
        qty: 1,
        cals: this.ingredient.cals.value,
        protien: this.ingredient.protien.value,
        carbs: this.ingredient.carbs.value,
        fat: this.ingredient.fats.value,
        realCals: this.ingredient.cals.value,
        realProtein: this.ingredient.protien.value,
        realCarbs: this.ingredient.carbs.value,
        realFat: this.ingredient.fats.value,
        ingredientType: this.ingredient.ingredientType,

        measure: '',
        measurement: [],
        measureunit: [],
        measurementUnitValue: '',
        name: '',
        searchIngredents: [],
        isSearchBoxShow: false
      });

      this.calculateMeasure(this.createdIngredientDetails.ingredientType, index);
      this.rows[index].measure = this.rows[index].measurement?.[0] || '';
    }
  });
}

 onAdd(item:any) {
 
  console.log('tag added: value is ' + item.value);
}

 onRemove(item:any) {
  console.log('tag removed: value is ' + item.value);
}
onSelect(item:any) {
  console.log('tag selected: value is ' + item);
}
 onTagEdited(item:any) {
  console.log(item);
  console.log('tag edited: current value is ' + item.tag);
}

selectedTags(data:any,name:any,type:any){
  if(data.target.checked == true){
    if(type == 1){
      this.receipe.diets.push(name);
    }else{
      this.receipe.allergies.push(name);
    }
    
  }else{
    if(type == 1){
      const index = this.receipe.diets.indexOf(name);
      this.receipe.diets.splice(index, 1);
    }else{
      const index = this.receipe.allergies.indexOf(name);
      this.receipe.allergies.splice(index, 1);
    }
  }
   
}


public searchIngredent(event: any,index:any) {
  clearTimeout(this.timeout);
  var $this = this;
  if(event.target.value != ''){
  this.timeout = setTimeout(function () {
    if (event.keyCode != 13) {
      $this.executeListing(event.target.value,index);
    }
  }, 500);
}else{
  this.rows[index].isSearchBoxShow=false;
}
}

private executeListing(value: string,index:any) {
  this.rows[index].isSearchBoxShow=true;
  this.showPleaseText=true;
  this.RecipeService.searchIngredient(value).subscribe((response:any) => {    
    //this.searchIngredientResult = response;
    this.showPleaseText=false;
    this.rows[index].searchIngredents=response;
    if(response == ''){
      this.showPleaseText=true;
      this.searchTextMessage="No Record Found";
    }else{
      this.showPleaseText=false;
      this.searchTextMessage="Please Wait..";
    }
   // console.log(response);
    
  });
}
blurTextbox(index:any){
  this.rows[index] = [];
  this.rows[index].isSearchBoxShow=false;
}
selectedIngredent(title: any, id: any, index: any, data: any) {
  console.log('Selected Ingredient Data:', data);

  this.rows[index].ingredientName = title;
  this.rows[index].food           = title;
  this.rows[index].ingredientId   = id;
  this.rows[index].isSearchBoxShow = false;

  this.rows[index].cals     = data.cals?.value || '0';
  this.rows[index].protien  = data.protien?.value || '0';
  this.rows[index].carbs    = data.carbs?.value || '0';
  this.rows[index].fat      = data.fats?.value || '0';

  this.rows[index].realCals    = data.cals?.value || '0';
  this.rows[index].realProtein = data.protien?.value || '0';
  this.rows[index].realCarbs   = data.carbs?.value || '0';
  this.rows[index].realFat     = data.fats?.value || '0';

  this.rows[index].ingredientType = data.ingredientType;

  this.calculateMeasure(data.ingredientType, index);

  if (this.rows[index].measurement?.length > 0) {
    const firstMeasure = this.rows[index].measurement[0];
    this.rows[index].measure              = firstMeasure;
    this.rows[index].measurementUnitValue = this.rows[index].measureunit[firstMeasure];
  }

  this.rows[index].qty = 1;
  this.addUnit(null, index, 1);
}



addUnit(unit:any,index:any,type:any){
  this.rows[index].isSearchBoxShow=false;
  if(type == 1){
    var unit =  this.rows[index].qty;
  }else{
    var unit = unit.target.value;
  }
  if(unit == ''){
    unit = 1;
  }
  
  if(this.rows[index].ingredientName != '' && unit> 0  && unit != ''){
  if(this.rows[index].ingredientName != ''){
    if(this.rows[index].measure != ''){
    let measure = this.rows[index].measure;
   // console.log(measure);
    let measureVal = this.rows[index].measureunit[measure];
    this.rows[index].measurementUnitValue = measureVal;
    let cals;
    let protien;
    let fat;
    let carbs;
    if(measure == 'Small Piece' || measure == 'Medium Piece' ||  measure == 'Large Piece'){
       cals = this.rows[index].realCals; 
        protien = this.rows[index].realProtein;
        carbs = this.rows[index].realCarbs;
        fat = this.rows[index].realFat;
    }else{
      cals = this.rows[index].realCals/100; 
      protien = this.rows[index].realProtein/100;
      carbs = this.rows[index].realCarbs/100;
      fat = this.rows[index].realFat/100;
    }
    
    this.rows[index].cals=formatNumber(unit*cals*measureVal,'en-US', '1.0-2');
    
    this.receipe.totalCals = this.rows.reduce((accumulator: number, object: any) => {
  return accumulator + parseFloat(object.cals.replace(/,/g, ''));
}, 0);
    
  this.rows[index].protien = formatNumber(unit * protien * measureVal, 'en-US', '1.0-2');

this.receipe.totalProtien = this.rows.reduce((accumulator: any, object: any) => {
  return parseFloat(accumulator) + parseFloat(object.protien.replace(/,/g, ''));
}, 0);

this.rows[index].carbs = formatNumber(unit * carbs * measureVal, 'en-US', '1.0-2');

this.receipe.totalCarbs = this.rows.reduce((accumulator: any, object: any) => {
  return parseFloat(accumulator) + parseFloat(object.carbs.replace(/,/g, ''));
}, 0);

    
    this.rows[index].fat = formatNumber(unit * fat * measureVal, 'en-US', '1.0-2');

this.receipe.totalFats = this.rows.reduce((accumulator: any, object: any) => {
  return parseFloat(accumulator) + parseFloat(object.fat.replace(/,/g, ''));
}, 0);

 
  }
  }
}
  
}
onFilechange(event: any) {
  this.file = event.target.files[0];
  this.fileName = event.target.files[0].name;
}


addNewTags() {
  const newTag = {
    name: this.tagName?.trim(),
    isDiet: this.tagType == 1
  };

  console.log('Sending tag payload:', newTag);

  const tagName = newTag.name;

  const request$ = newTag.isDiet
    ? this.RecipeService.addDiet(tagName)
    : this.RecipeService.addAllergy(tagName);

  request$.subscribe({
    next: (response: any) => {
      this.toastr.success('Tag added successfully.');
      this.visibleTag = false;
      this.tagName = '';
      this.tagType = '';

      this.fetchTags();
    },
    error: (err: unknown) => {
      console.error('Backend error:', err);
      this.toastr.error('Failed to add tag.');
    }
  });
}


fetchTags() {
  const localDietTags = this.diets.map((tag: string) => ({ tagName: tag }));
  const localAllergyTags = this.allergies.map((tag: string) => ({ tagName: tag }));

  let dietTagsFromApi: { tagName: string }[] = [];
  let allergyTagsFromApi: { tagName: string }[] = [];

  let completed = 0;

  const finish = () => {
    if (completed === 2) {
      const allDietTags = this.deduplicateTags([...localDietTags, ...dietTagsFromApi]);
      const allAllergyTags = this.deduplicateTags([...localAllergyTags, ...allergyTagsFromApi]);

      this.tags = {
        dietTags: allDietTags,
        allergyTags: allAllergyTags
      };
    }
  };

  this.RecipeService.getDiets().subscribe({
    next: (res: any) => {
      dietTagsFromApi = Array.isArray(res?.tags) ? res.tags : [];
      completed++;
      finish();
    },
    error: (err: unknown) => {
      console.error('Error fetching diet tags:', err);
      completed++;
      finish();
    }
  });

  this.RecipeService.getAllergies().subscribe({
    next: (res: any) => {
      allergyTagsFromApi = Array.isArray(res?.tags) ? res.tags : [];
      completed++;
      finish();
    },
    error: (err: unknown) => {
      console.error('Error fetching allergy tags:', err);
      completed++;
      finish();
    }
  });
}



deduplicateTags(tags: { tagName: string }[]): { tagName: string }[] {
  const seen = new Set();
  return tags.filter(tag => {
    const lowerName = tag.tagName.toLowerCase();
    if (seen.has(lowerName)) return false;
    seen.add(lowerName);
    return true;
  });
}




calculateMeasure(ingredientType: any, index: any) {
  console.log('Ingredient Type:', ingredientType);
  console.log('Index:', index);

  // Get all measures from the service
  const allMeasures = this.RecipeService.getAllMeasure();
  
  // Initialize the measure unit default
  this.measureUnit = 'g';

  // Ensure the row exists
  if (!this.rows[index]) {
    this.rows[index] = {
      measurement: [],
      measureunit: {}
    };
  }

  // Assign measures based on ingredient type
  switch (ingredientType) {
    case 'Egg':
      this.rows[index].measurement = allMeasures[0] || [];
      this.rows[index].measureunit = allMeasures[7] || {};
      break;
    case 'Liquid':
      this.rows[index].measurement = allMeasures[1] || [];
      this.rows[index].measureunit = allMeasures[8] || {};
      this.measureUnit = 'ml';
      break;
    case 'Semiliquid':
      this.rows[index].measurement = allMeasures[2] || [];
      this.rows[index].measureunit = allMeasures[9] || {};
      break;
    case 'Solid':
      this.rows[index].measurement = allMeasures[3] || [];
      this.rows[index].measureunit = allMeasures[10] || {};
      break;
    case 'Semisolid':
      this.rows[index].measurement = allMeasures[4] || [];
      this.rows[index].measureunit = allMeasures[11] || {};
      break;
    case 'Oil':
      this.rows[index].measurement = allMeasures[5] || [];
      this.rows[index].measureunit = allMeasures[12] || {};
      break;
    case 'Meat':
      this.rows[index].measurement = allMeasures[6] || [];
      this.rows[index].measureunit = allMeasures[13] || {};
      break;
    default:
      console.warn(`Unknown ingredient type: ${ingredientType}`);
      break;
  }

  console.log('Measurement options:', this.rows[index].measurement);
  console.log('Measure units:', this.rows[index].measureunit);
}
}